<template>
  <custom-dialog
    :openDialog="isOpen"
    :widthDialog="'800px'"
    :classDialog="'createDialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #header>
      <h5 class="dialogTitle margin-left-10">
        Gia hạn báo cáo công việc
      </h5>
    </template>

    <template #body>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="200px"
      >
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="Thời hạn hoàn thành">
              <el-date-picker
                v-model="form.deadline"
                type="date"
                size="medium"
                class="style-fullWidth input-border__bottom input-border__radius__0"
                placeholder="dd/mm/yyyy"
                format="dd/MM/yyyy"
                :disabled="true"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Ngày hoàn thành tiếp theo" prop="completeDate">
              <el-date-picker
                v-model="form.completeDate"
                type="date"
                size="medium"
                class="style-fullWidth input-border__bottom input-border__radius__0"
                placeholder="dd/mm/yyyy"
                format="dd/MM/yyyy"
                :picker-options="completeDatePickerOptions"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Lý do chậm tiến độ" prop="lateReason">
              <el-input
                v-model="form.lateReason"
                type="textarea"
                placeholder="Lý do chậm tiến độ"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                show-word-limit
                maxlength="5000"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row form-button__action flex__right">
        <el-button
          size="medium"
          type="success"
          class="addDocs  color__white bg__blue btn-none__border"
          @click="save"
        >
          <i class="far fa-check-circle font-size__small"></i>
          &nbsp;Lưu
        </el-button>
        <el-button
          type="info"
          size="medium"
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
        >Bỏ qua
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>

<script>
import CustomDialog from "../../common/custom-dialog";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import Vue from "vue";
import errorMessageFilter from "../../../filters/errorMessageFilter";
import hcCVTrongTamService from "../../../services/congviectrongtam/hcCVTrongTamService"

export default {
  name: "hc-congviectrongtam-gia-han-dialog",
  props: ["isOpen", "id"],
  mixins: [handleRequestErrorMixin],
  components: {CustomDialog},

  data() {
    return {
      form: {
        deadline: null,
        completeDate: null,
        lateReason: null
      },
      rules: {
        completeDate: null,
        lateReason: null
      },
      hcCVTrongTam: null,
      completeDatePickerOptions: {
        disabledDate: null
      }
    };
  },

  created() {
    this.initValidationRules();
    this.loadHcCongViecTrongTam().then(() => this.initForm());
  },

  methods: {
    initForm() {
      if(this.hcCVTrongTam) {
        if (this.hcCVTrongTam.nextDeadline2) {
          this.form.deadline = new Date(this.hcCVTrongTam.nextDeadline2);
        } else if (this.hcCVTrongTam.nextDeadline) {
          this.form.deadline = new Date(this.hcCVTrongTam.nextDeadline);
        } else if (this.hcCVTrongTam.deadline) {
          this.form.deadline = new Date(this.hcCVTrongTam.deadline);
        } else {
          this.form.deadline = null;
        }
      }

      this.completeDatePickerOptions.disabledDate = time =>
        !(!this.form.deadline || time.getTime() > this.form.deadline.getTime());
    },

    loadHcCongViecTrongTam() {
      return hcCVTrongTamService.findById(this.id)
        .then(response => (this.hcCVTrongTam = response.data));
    },

    initValidationRules() {
      let defaultRequiredConstrains = {
        required: true,
        message: "Trường dữ liệu bắt buộc",
        trigger: "blur"
      };
      Vue.set(this.rules, "completeDate", [defaultRequiredConstrains]);
      Vue.set(this.rules, "lateReason", [defaultRequiredConstrains]);
    },

    convertToSubmitForm() {
      return {
        completeDate: this.form.completeDate
          ? this.form.completeDate.getTime()
          : null,
        lateReason: this.form.lateReason
      };
    },

    validateForm() {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => {
          if (!valid) {
            this.$message({
              message: "Có lỗi nhập liệu. Vui lòng kiểm tra lại",
              type: "error"
            });
          } else {
            resolve();
          }
        });
      });
    },

    save() {
      return this.validateForm()
        .then(() => {
          let submitForm = this.convertToSubmitForm();
          return hcCVTrongTamService
            .giaHan(this.id, submitForm)
            .then(response => response.data);
        })
        .then(hcCVTrongTam => {
          this.$message({
            message: errorMessageFilter({
              errorCode: "hcQuyTrinh.giaHanSuccess"
            }),
            type: "success"
          });
          this.$emit("success", {result: hcCVTrongTam});
        })
        .catch(error => {
          this.commonHandleRequestError(error);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/adminstration/congviectrongtam/hc-congviectrongtam-gia-han-dialog.vue